module.exports = __webpack_public_path__ + "static/media/character-05.514858c8.png";